export const notCountProject = ["Nuevo pruebas"];

export const statusClickup = {
	pendiente: "pendiente",
	proceso: "en proceso",
	test: "testing",
	cancelado: "cancelado",
	diferido: "diferido",
	complete: "completado",
};

export const loadingProject = {
	table: false,
	form: false,
	delete: false,
	projectDetail: false,
	selectClickup: false,
	buttonEdit: false,
	buttonConclued: false,
};

export const projectDetailsInit = {
	description: "",
	size: "M",
	client: [],
	properties: [],
	budgetHrs: {
		develoment: 200,
		planning: 100,
		budget: 300,
		web: 0,
		art3d: 0,
		unity: 0,
		design: 0,
	},
	projectRed: [],
	hasProjectRed: false,
	retrospective: [],
	hasRetrospective: false,
	commentCancel: [],
	hasCommentCancel: false,
	percentage: 2.14,
	subtract: 293.58,
	hrsTotal: 6.42,
	hrsTotalByClickup: 6.42,
	hrsTotalExtraTime: 0,
	hrsTotalExtraResource: 0,
	hasComments: false,
	name: "Test proyect",
	status: "ACTIVO",
	plataforms: [],
	plataformsView: "",
	team: {
		web: {
			name: "PROGRAMACIÓN WEB",
			iteams: [],
		},
		art3d: {
			name: "ARTE 3D",
			iteams: [],
		},
		desing: {
			name: "DISEÑO UI/UX",
			iteams: [],
		},
		unity: {
			name: "PROGRAMACIÓN UNITY",
			iteams: [],
		},
		comercial: {
			name: "COMERCIAL",
			iteams: [],
		},
		responsible: {
			name: "RESPONSABLE",
			iteams: [],
		},
		leader: {
			name: "LÍDER",
			iteams: [],
		},
	},
	tableIndication: [
		{
			keyId: "art3d",
			name: "ARTE 3D",
			color: "#8DC881",
			tracked: 0,
			budget: 100,
			subtract: 100,
			consume: 0,
		},
		{
			keyId: "web",
			name: "WEB",
			color: "#8DC881",
			tracked: 23.5,
			budget: 100,
			subtract: 76.5,
			consume: 23.5,
		},
		{
			keyId: "unity",
			name: "UNITY",
			color: "#8DC881",
			tracked: 0,
			budget: 100,
			subtract: 100,
			consume: 0,
		},
		{
			keyId: "design",
			name: "DISEÑO UI/UX",
			color: "#8DC881",
			tracked: 0,
			budget: 100,
			subtract: 100,
			consume: 0,
		},
		{
			keyId: "planning",
			name: "PLANEACIÓN",
			color: "#8DC881",
			tracked: 0,
			budget: 200,
			subtract: 200,
			consume: 0,
		},
		{
			keyId: "testing",
			name: "TESTING",
			color: "#8DC881",
			tracked: 0,
			budget: 0,
			subtract: 0,
			consume: 0,
		},
	],
	graphArea: [
		{
			id: "ARTE 3D",
			label: "ARTE 3D",
			value: 0,
			color: "#7C4DFF",
		},
		{
			id: "PROGRAMACIÓN WEB",
			label: "WEB",
			value: 23.5,
			color: "#2ECD6F",
		},
		{
			id: "PROGRAMACIÓN UNITY",
			label: "UNITY",
			value: 0,
			color: "#02BCD4",
		},
		{
			id: "DISEÑO UI/UX",
			label: "DISEÑO UI/UX",
			value: 0,
			color: "#FF4081",
		},
		{
			id: "PLANEACIÓN",
			label: "PLANEACIÓN",
			value: 0,
			color: "#940bab",
		},
		{
			id: "TESTING",
			label: "TESTING",
			value: 0,
			color: "#9cc",
		},
	],
	backups: [],
	extraResources: [],
	categories: [],
	categoriesView: "",
	extraTime: [],
	dates: {
		weeks: 0,
		start: "2024-05-02",
		end: "",
		finished: "",
		expected: "",
		deadLine: "",
		today: "2024-05-13",
	},
	pauses: [],
	isProjectRed: false,
};
